import React from 'react'

import './css/index.css'

import btn_img from './images/blue_button1.png'

import btn_img_ru from './images/blue_button2.png'

import {
  isIOS,
  isAndroid
} from "react-device-detect";

class OpenStoreButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);

    this.state = {
      
    };
  }

  androidURL = "market://details?id=com.idspe.tanks2";

  iosURL = "https://itunes.apple.com/app/id1344713773";

  handleClick() {
    
    if(isIOS){
      //console.log("iOS: open store button pressed! ");
      window.location.href = this.iosURL;
    }
    else 
    {
      if(isAndroid){
        //console.log("Android: open store button pressed! ");
        window.location.href = this.androidURL;
      }
      else
      {
        //console.log("non-mobile device");
        window.location.href = this.androidURL;
      }
    }
	
	//как вызвать стейт в верхнем элементе?
  }

  render() {
    return (
      <div>
        <button title={this.props.title} className="footerButton2" onClick={this.handleClick}>
          <img src={this.props.ru == "true" ? btn_img_ru : btn_img}/>
        </button>
      </div>
    );
  }
}
export default OpenStoreButton


// WEBPACK FOOTER //
// ./src/OpenStoreButton.js